export default class DomUtils {
  constructor() {
    this.timeout = 5000;
  }

  /**
   * Waits for a DOM element matching the selector to appear within a given time frame.
   * @param {string} selector - A CSS selector for the target element.
   * @param {HTMLElement} [parent=document] - The parent element to search within.
   * @returns {Promise<HTMLElement>} - Resolves with the found element or rejects on timeout.
   */
  waitForElement(selector, parent = document) {
    return new Promise((resolve, reject) => {
      const start = Date.now();
      const check = () => {
        const element = parent.querySelector(selector);
        if (element) return resolve(element);
        if (Date.now() - start > this.timeout) return reject(new Error(`Timeout waiting for element: ${selector}`));
        requestAnimationFrame(check);
      };
      check();
    });
  }
}